<!-- eslint-disable -->
<template lang="pug">
    div
        olympiad-form(v-if="isShowForm" :id="olympiadId")
            .olympiad-form__title(slot="title")
                .title__text {{ $i18n.t('olympiads.olympiads_edit_editOlympiad') }}
                cs-button.title__button(
                    color="blue"
                    pattern="primary-outline",
                    @click="$router.push({name: 'olympiads:students-list', params: {id: olympiadId}})"
                    narrow
                )
                    | {{ $i18n.t('olympiads.olympiads_edit_showParticipants') }}
            template(slot="button") {{ $i18n.t('olympiads.olympiads_olympiadForm_publish') }}
        div(v-else) {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
</template>

<script>
    /*eslint-disable*/
    import BoxHeader from '../../elements/BoxHeader.vue';
    import OlympiadForm from './OlympiadForm.vue';
    import {mapState} from 'vuex';

    export default {
        props: {
            olympiadId: [Number, String]
        },
        beforeRouteLeave(to, from, next) {
            if (to.name !== 'olympiad-level:create') {
                this.$store.dispatch('setOlympiad', null)
            }
            next()
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isShowForm () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            }
        },
        components: {
            BoxHeader,
            OlympiadForm
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-form__title {
        position: relative;
        width: 100%;
        min-height: 35px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        @include media($xlg) {
            flex-direction: row;
        }
    }

    .title__button {
        margin-top: 8px;
        @include media($xlg) {
            margin-top: 0;
            position: absolute;
            right: 0;
            top: 0;
        }
    }
</style>
